export default __webpack_public_path__ + "static/media/VodacomMusic.23dd82c8.svg";